import type React from 'react'
import styled from 'styled-components'

const DashboardLoadContainer = styled.div`
  display: grid;
  place-items: center;
`

const DashboardLoad: React.FC = () => {
  return (
    <DashboardLoadContainer>
      <h1>Loading Dashboard...</h1>
      <img src="/assets/svg/building.svg" style={{ maxWidth: 400 }} alt="building" />
    </DashboardLoadContainer>
  )
}

export default DashboardLoad
